/** @format */

import React from 'react';
import { FACTS_FIELD_KEYS } from '../utilities';
import './styles.scss';
import { Unit, checkIfValueIsValid, formatValue } from '../common';

export const getChargeData = (props) => {
  const { dataSet, objectText } = props;

  const factKey = FACTS_FIELD_KEYS.BASE_INFO;

  const chargeData = dataSet[factKey];

  const ChargeFactsRow = ({
    facts,
    priceData = null,
    isDescription = false
  }) => {
    const factFieldName = facts?.factFieldName;
    if (checkIfValueIsValid(facts?.value)) {
      if (isDescription) {
        return (
          <>
            <div className='object-listing-accordian-list object-listing-accordian-list-no-border'>
              <div className='object-listing-accordian-list-left'>
                {objectText?.[`${factKey}Obj`]?.[factFieldName]?.label ||
                  objectText?.[factKey]?.[factFieldName]?.label ||
                  facts?.factFieldName}
              </div>
              <div className='object-listing-accordian-list-right'></div>
            </div>

            <div className='object-listing-accordian-list object-listing-accordian-list-no-border'>
              <div className='common-descriptions-fact-body'>
                {facts?.value}
              </div>
            </div>
          </>
        );
      } else {
        return (
          <div className='object-listing-accordian-list object-listing-accordian-list-no-border'>
            <div className='object-listing-accordian-list-left'>
              {objectText?.[`${factKey}Obj`]?.[factFieldName]?.label ||
                objectText?.[factKey]?.[factFieldName]?.label ||
                facts?.factFieldName}
            </div>
            <div className='object-listing-accordian-list-right'>
              {formatValue({
                facts,
                krFields: ['monthlyFee']
              })}
              <Unit unit={priceData?.currency} />
            </div>
          </div>
        );
      }
    }

    return <></>;
  };

  const ChargeSection = () => {
    return (
      <div className='charge-data-body'>
        <ChargeFactsRow
          key='monthlyFee'
          facts={{
            factFieldName: 'monthlyFee',
            value: chargeData?.monthlyFee
          }}
          priceData={{
            currency: dataSet?.price?.currency
          }}
        />
        <ChargeFactsRow
          key='commentary'
          facts={{
            factFieldName: 'commentary',
            value: chargeData?.commentary
          }}
          isDescription={true}
        />
      </div>
    );
  };

  return {
    component: <ChargeSection />,
    factsCount: 0
  };
};
